<template>
  <v-dialog v-model="dialog" width="700" height="700" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
    <!-- <v-card>
      <v-card-title class="headline grey lighten-3">
        <v-layout align-center>
          <v-flex grow>
            {{lease.showStreetAddress}}
          </v-flex>
          <v-spacer />
          <v-chip>
            {{actionGroup.label}}
          </v-chip>
          <v-btn flat icon class="align--right" @click.stop="accept()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-card-text style="padding-bottom: 70px; " class="container">
        <div class="md6">
          <template v-for="contact in contacts">
            <v-list-tile two-line :key="contact.email" class="lease" flex>
              <v-list-tile-content class="contact">
                <v-chip style="width: 120px">
                  <v-icon :color='contact.color'>person</v-icon>
                  {{contact.name}}
                </v-chip>
                <v-chip style="width: 200px">
                  <v-icon :color='contact.color'>email</v-icon>
                  <span>{{contact.email}}</span>
                </v-chip>
                <v-chip style="width: 120px">
                  <v-icon :color='contact.color'>phone</v-icon>
                  <span>{{contact.phone}}</span>
                </v-chip>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </div>
      </v-card-text>
      <v-divider />
 -->

    <v-card v-if="statusLabel">
      <v-card-title class="headline orange lighten-3 d-flex flex-row">
        <v-layout align-center>
          <v-chip>{{statusLabel}}</v-chip>
          <v-flex grow>{{lease.showStreetAddress}}</v-flex>
          <v-spacer />
          <v-btn flat icon class="align--right" @click.stop="accept('OK')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout row class="mb-2" style="padding: 0 36px;">
          <v-flex xs5>
            <v-chip>
              <v-icon color="green">calendar_today</v-icon>{{lease.checkin_date}} to {{lease.checkout_date}}
            </v-chip>
          </v-flex>
          <v-flex xs5>
            <v-chip>
              <v-icon color="red">alarm</v-icon>{{lease.leftDays}} days left
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-title>
        <v-layout row class="mb-2" style="padding: 0 36px;">
          <v-flex xs5>
            <h2 class="title">
              <v-icon color="blue">house</v-icon>Owner
            </h2>
            <v-divider class="my-2 primary" />
            <v-list dense>
              <v-layout row>
                <v-chip>
                  <v-icon color="primary">person</v-icon>{{lease.house.owner_firstname + ' ' + lease.house.owner_lastname}}
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip>
                  <v-icon color="primary">phone</v-icon>{{lease.house.owner_phone}}
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip>
                  <v-icon color="primary">email</v-icon>{{lease.house.owner_email}}
                </v-chip>
              </v-layout>
              <!-- <v-divider class="my-1 primary" />
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 0 }" @click.stop="lease.status === 0 && confirm('Sending notification to owner', '', emailNotification)">
                  <v-icon color="primary">email</v-icon>Send reminding notice
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 1 }" @click.stop="lease.status === 1 && confirm('Owner\'s response', 'Owner agrees to extent the lease')">
                  <v-icon color="primary">attribution</v-icon>Agree to extent the lease
                  <v-icon color="primary" right >task_alt</v-icon>
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 1 }" @click.stop="lease.status === 1 && confirm('Owner\'s response', 'Owner won\'t extent the lease')">
                  <v-icon color="primary">attribution</v-icon>Won't extent the lease
                  <v-icon color="primary" right >task_alt</v-icon>
                </v-chip>
              </v-layout> -->
            </v-list>
          </v-flex>
          <v-flex xs5>
            <h2 class="title">
              <v-icon color="green">person</v-icon>Tenant
            </h2>
            <v-divider class="my-2 green" />
            <v-list dense>
              <v-layout row>
              <v-chip>
                <v-icon color="green">person</v-icon>{{tenant.tenant_name}}
              </v-chip>
              </v-layout>
              <v-layout row>
              <v-chip>
                <v-icon color="green">phone</v-icon>{{tenant.tenant_phone}}
              </v-chip>
              </v-layout>
              <v-layout row>
              <v-chip>
                <v-icon color="green">email</v-icon>{{tenant.tenant_email}}
              </v-chip>
              </v-layout>
              <!-- <v-divider class="my-1 primary" />
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 0 }" @click.stop="lease.status === 0 && confirm('Sending notification to owner', '', emailNotification)">
                  <v-icon color="green">email</v-icon>Email renewal invitation
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 0 }" @click.stop="lease.status === 0 && confirm('Sending notification to owner', '', emailNotification)">
                  <v-icon color="red">email</v-icon>Email terminate notice
                </v-chip>
              </v-layout>
              <v-layout row>
              <v-chip @click.stop="confirm('Tenant\'s feedback', 'Tenant says: ...')">
                <v-icon color="green">mood_bad</v-icon>Other comments
              </v-chip>
              </v-layout> -->
            </v-list>
          </v-flex>
          <v-flex xs5>
            <h2 class="title">
              <v-icon color="secondary">note_alt</v-icon>Manager
            </h2>
            <v-divider class="my-2 secondary" />
            <v-list dense>
              <v-layout row>
              <v-chip>
                <v-icon color="secondary">person</v-icon>{{account.account}}
              </v-chip>
              </v-layout>
              <v-layout row>
              <v-chip>
                <v-icon color="secondary">phone</v-icon>{{account.phone}}
              </v-chip>
              </v-layout>
              <v-layout row>
              <v-chip>
                <v-icon color="secondary">email</v-icon>{{account.email}}
              </v-chip>
              </v-layout>
              <!-- <v-divider class="my-1 primary" />
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 0 }" @click.stop="lease.status === 0 && confirm('Sending notification to owner', '', emailNotification)">
                  <v-icon color="green">upload</v-icon>Upload renewal contract
                </v-chip>
              </v-layout>
              <v-layout row>
                <v-chip :class="{ disabled: lease.status !== 0 }" @click.stop="lease.status === 0 && confirm('Sending notification to owner', '', emailNotification)">
                  <v-icon color="red">indeterminate_check_box</v-icon>arrange checkout
                </v-chip>
              </v-layout>
              <v-layout row>
              <v-chip @click.stop="confirm('Manager\'s notice', 'Issues: ...')">
                <v-icon color="secondary">mood_bad</v-icon>Other comments
              </v-chip>
              </v-layout> -->
            </v-list>
          </v-flex>
          <!-- <v-flex xs5>
            <h2 class="title">
              <v-layout>
                <v-icon color="secondary">handyman</v-icon>Handyman
              </v-layout>
            </h2>
            <v-divider class="my-2 secondary" />
            <v-list dense>
              <v-layout style="height: 40px;">
                <v-icon color="secondary">person</v-icon>
                <v-select
                  :items="['handymenItems', 'handymenItems']"
                  label="Choose an handyman"
                  solo flat hide-details outlined
                ></v-select>
              </v-layout>
              <template>
                <v-chip>
                  <v-icon color="secondary">phone</v-icon>'{selectedHandyman.phone}'
                </v-chip>
                <v-chip>
                  <v-icon color="secondary">email</v-icon>'{selectedHandyman.email}'
                </v-chip>
                <v-divider class="my-1 primary" />
                <v-chip :class="{ disabled: lease.status >= 8 }" @click.stop="lease.status < 9 && confirm('Handyman confirms', 'Bill on owner\'s')">
                  <v-icon color="secondary">house</v-icon>Bill on owner's
                </v-chip>
                <v-chip :class="{ disabled: lease.status >= 8 }" @click.stop="lease.status < 9 && confirm('Handyman confirms', 'Bill on tenant\'s')">
                  <v-icon color="secondary">person</v-icon>Bill on tenant's
                </v-chip>
                <v-chip :class="{ disabled: lease.status >= 8 }" @click.stop="lease.status < 9 && confirm('Handyman refuses', 'Handyman explains that...')">
                  <v-icon color="secondary">sentiment_very_dissatisfied</v-icon>Cannot fix
                </v-chip>
              </template>
            </v-list>
          </v-flex> -->
        </v-layout>
      </v-card-title>

      <v-card-text style="padding: 0 20px;" class="container scroll">
        <v-divider class="my-1 primary" />
        <v-flex v-if="lease">
          <v-list v-for="note in lease.note" :key="note.id" class="lease">
            <v-chip style="width: 240px">
              <v-icon color='red'>notes</v-icon>
              {{note.account.account}}@{{note.created_at}}
            </v-chip>
            <v-chip style="width: 400px">
              <span>{{note.message}}</span>
            </v-chip>
          </v-list>
        </v-flex>
      </v-card-text>
      <v-divider />

      <v-card-actions class="status-action-group" v-if="!actionGroup.filter || actionGroup.filter()">
        <v-btn class="status-action" v-for="func in actionGroup.functions" :key="func.color" :color="func.color" @click.stop="func.action(lease)">
          {{func.title}}
        </v-btn>
        <br/>
        <v-btn class="status-action" color="secondary" @click.stop="markComplete()">
          Mark this lease to Complete
        </v-btn>
        <input v-show="false" id="" ref="uploadTenantContract" type="file" @change="finishUploadTenantContract($event)"/>
        <input v-show="false" id="" ref="uploadRenewalConfirmation" type="file" @change="finishUploadRenewalConfirmation($event)"/>
      </v-card-actions>
    </v-card>
    <ConfirmDialog ref="dlg"/>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import leaseStatus from '@/helpers/lease_status';
import tenantContract from '@/template/lease/tenantContract';
import renewalInvitation from '@/template/lease/renewalInvitation';
import renewalConfirmation from '@/template/lease/renewalConfirmation'
import terminationNotice from '@/template/lease/terminationNotice'
import ConfirmDialog from '@/components/ConfirmDialog';
import LeaseInfo from '../houselist/details/LeaseInfo.vue';

export default {
  name: 'CreateLeaseTaskDialog',
  components: {
    ConfirmDialog,
    LeaseInfo,
  },

  data() {
    return {
      busy: false,
      dialog: false,
      statusActionGroup: [{
        status: leaseStatus.Created,
        label: 'Created',
        functions: [
          {title: 'Send tenant contract', color: 'primary', action: this.sendTenantContract},
          {title: 'Cancel the tenant contract', color: 'warning', action: this.cancelContract}
        ]
      }, {
        status: leaseStatus.Confirming,
        label: 'Confirming',
        functions: [
          {title: 'Upload tenant contract to confirm',color: 'primary',action: this.uploadTenantContract},
          {title: 'Cancel the tenant contract', color: 'warning', action: this.cancelContract}]
      }, {
        status: leaseStatus.Running,
        label: 'Running',
        filter: () => this.leftDays <= 90,
        functions: [
          {title: 'Send renewal invitation to tenant', color: 'primary', action: this.sendRenewalInvitation},
          {title: 'Send termination notice to tenant', color: 'warning', action: this.sendTerminationNotice},
        ]
      }, {
        status: leaseStatus.RenewalInviting,
        label: 'Renewal Inviting',
        functions: [
          {title: 'Upload Renewal Confirmation', color: 'primary', action: this.uploadRenewalConfirmation},
          {title: 'Send termination notice to tenant', color: 'warning', action: this.sendTerminationNotice},
        ]
      }, {
        status: leaseStatus.RenewalConfirming,
        label: 'Renewal Confirming',
        functions: [
          {title: 'Extend lease period', color: 'primary', action: this.sendRenewalConfirmation},
        ]
      }, {
        status: leaseStatus.RenewalRefused,
        label: 'Renewal Refused',
        functions: [
          {title: 'Upload Renewal Confirmation', color: 'primary', action: this.uploadRenewalConfirmation},
        ]
      }]
    }
  },
  computed: {
    ...mapGetters({
      lease: 'LeaseList/getSelectedLease',
      account: 'User/getUser',
    }),
    statusLabel() {
      return this.actionGroup().label;
    },
    actionGroup() {
      return this.statusActionGroup.find(group => group.status === this.lease.status);
    },
    contacts() {
      const data = this.lease.tenant.map(t => ({
        avatar: 'TE',
        color: 'blue',
        name: t.tenant_name,
        email: t.tenant_email,
        phone: t.tenant_phone,
      }));
      const house = this.lease.house;
      data.unshift({
        avatar: 'OW',
        color: 'indigo',
        name: house.owner_firstname + ' ' + house.owner_lastname,
        email: house.owner_email,
        phone: house.owner_phone,
      });
      console.log('contacts', data)
      return data;
    },
    tenantNames() {
      return this.lease.tenant.map(t => t.tenant_name).join(', ');
    },
    tenantEmails() {
      return this.lease.tenant.map(t => t.tenant_email).join(', ');
    },
    leftDays() {
      const now = moment();
      const leaseCheckoutDate = moment(this.lease.checkout_date, 'YYYY-MM-DD');
      const days = leaseCheckoutDate.diff(now, 'days')
      return days;
    },
    statusLabel() {
      const map = this.statusActionGroup.find(map => map.status === this.lease.status);
      return map? map.label: '';
    },
    tenant() {
      const tenants = this.lease.tenant;
      if (tenants && tenants.length > 0) {
        return tenants[0];
      }
      return {
        tenant_name: 'Unknown',
        tenant_email: 'Not registered',
        tenant_phone: 'Not registered',
      }
    },
    leftDays() {
      const now = moment();
      const leaseCheckoutDate = moment(this.lease.checkout_date);
      const days = leaseCheckoutDate.diff(now, 'days')
      return days;
    },

  },
  methods: {
    ...mapActions({
      sendNotification: 'LeaseList/sendNotification',
      uploadFile: 'HouseList/Lease/uploadFile',
      createTask: 'TaskList/createTask',
      updateLease: 'LeaseList/updateLease',
    }),
    gotoDetails() {
      this.$emit('update:showLeaseTaskDialog', false)
      this.$router.push({
        path: `/houses/${this.lease.house_id}/leases/${this.lease.id}/tenant`,
      })
    },
    close() {
      this.$emit('update:showLeaseTaskDialog', false)
    },
    async sendTenantContract() {
      this.busy = true;
      const email = { to: this.tenantEmails, subject: tenantContract.subject(this.lease), content: tenantContract.body(this.lease)};
      await this.sendNotification(email);
      this.busy = false;
      this.updateLease({id: this.lease.id, status: leaseStatus.Confirming})
    },
    async cancelContract() {
      await this.updateLease({id: this.lease.id, status: leaseStatus.Discard})
      await this.close();
    },
    async uploadTenantContract() {
      this.$refs.uploadTenantContract.click()
    },
    async finishUploadTenantContract(event) {
      if (event.target.files.length > 0) {
        await this.uploadFile({
          file: event.target.files[0],
          tenantId: this.lease.tenant[0].id,
          houseId: this.lease.house.id,
          leaseId: this.lease.id,
        })
        await this.updateLease({id: this.lease.id, status: leaseStatus.Running})
      }
    },
    async finishUploadRenewalConfirmation(event) {
      if (event.target.files.length > 0) {
        await this.uploadFile({
          file: event.target.files[0],
          tenantId: this.lease.tenant[0].id,
          houseId: this.lease.house.id,
          leaseId: this.lease.id,
        })
        await this.updateLease({id: this.lease.id, status: leaseStatus.RenewalConfirming})
      }
    },
    async sendRenewalInvitation() {
      this.busy = true;
      this.lease.tenantNames = this.tenantNames;
      const email = { to: this.tenantEmails, subject: renewalInvitation.subject(this.lease), content: renewalInvitation.body(this.lease)};
      await this.sendNotification(email);
      this.busy = false;
      await this.updateLease({id: this.lease.id, status: leaseStatus.RenewalInviting})
      await this.close();
    },
    async sendRenewalConfirmation() {
      this.busy = true;
      this.lease.tenantNames = this.tenantNames;
      const email = { to: this.tenantEmails, subject: renewalConfirmation.subject(this.lease), content: renewalConfirmation.body(this.lease)};
      await this.sendNotification(email);
      this.busy = false;
      const extend = moment(this.lease.checkout_date).add(1, 'y').format('YYYY-MM-DD');
      console.log('sendRenewalConfirmation',{extend})
      await this.updateLease({id: this.lease.id, checkout_date: extend})
      await this.updateLease({id: this.lease.id, status: leaseStatus.Running})
    },
    async sendTerminationNotice() {
      this.busy = true;
      this.lease.tenantNames = this.tenantNames;
      const email = { to: this.tenantEmails, subject: terminationNotice.subject(this.lease), content: terminationNotice.body(this.lease)};
      await this.sendNotification(email);
      const timestamp = moment(this.lease.checkout_date).unix();
      await this.createTask({house_id: this.lease, title: 'inspections', timestamp});
      this.busy = false;
      await this.updateLease({id: this.lease.id, status: leaseStatus.RenewalRefused})
      await this.close();
    },
    async uploadRenewalConfirmation() {
      this.$refs.uploadRenewalConfirmation.click()
    },

    async confirm(title, newNote, actionConfirmed) {
      try {
        newNote = await this.$refs.dlg.open(title, newNote)
        await this.comment({repair: this.repair, note: newNote});
        actionConfirmed(newNote)
      }
      catch(reason) {
      }
    },
    open() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },
    accept(str) {
      this.dialog = false;
      this.resolve(str);
    },
    cancel(str) {
      this.dialog = false;
      this.reject(str);
    },
  },


}
</script>

<style scoped>
  .avatar {
    padding-right: 0.5rem;
  }
  .status-action-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .status-action {
    width: 400px;
    padding: 1rem;
    margin: 1rem;
  }
  .v-list__tile__action {
    min-width: 0;
  }
  .contact {
    display: flex;
    width: 400px;
    flex-wrap: wrap;
  }
  .contact:hover {
    background-color : lightgray;
    border-radius: 5px;
  }
</style>